var gql = require("@apollo/client").gql;

const OPERATOR_AVAILABILITY_PROVIDER_QUERY = gql`
	query OPERATOR_AVAILABILITY_PROVIDER($global_id: Int!, $url_region: String!) {
		operatorAvailabilityProvider(global_id: $global_id, url_region: $url_region) {
			name
			url_name
			mobile_operator
			region {
				url
			}
		}
	}
`;

export default OPERATOR_AVAILABILITY_PROVIDER_QUERY;
